module.exports = __webpack_public_path__ + "static/media/portal-cta-background.56a217f7.jpg";